import { confirmable } from 'react-confirm';
import StackedModal from './stacked_modal';
import { useTranslation } from 'react-i18next';
import { useState, useCallback, useRef } from 'react';
import { Box } from '@mui/material';
import { TextField } from '@shopify/polaris';
import i18n from 'src/locales/i18n';

i18n.loadNamespaces(['printing']);

function PrintlabelDialog({ show, proceed, title, content }) {
  const { t } = useTranslation(['common', 'printing']);
  const [quantity, setQuantity] = useState('1');
  const isComposing = useRef(false);

  const handleChange = useCallback((newValue) => {
    if (isComposing.current) return;

    const numbersOnly = newValue.replace(/[^0-9]/g, '');

    if (numbersOnly === '') {
      setQuantity('');
      return;
    }

    setQuantity(String(parseInt(numbersOnly, 10)));
  }, []);

  return (
    <StackedModal
      isOpen={show}
      title={title || t('common:confirmation.barcode_print')}
      content={
        <Box
          display="flex"
          flexDirection="column"
          width="100%"
          rowGap={1}
        >
          <span>{content || t('printing:number_of_labels')}</span>
          <TextField
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            value={quantity}
            onChange={handleChange}
            onCompositionStart={() => {
              isComposing.current = true;
            }}
            onCompositionEnd={(e) => {
              isComposing.current = false;
              handleChange(e.target.value);
            }}
            onKeyDown={(e) => {
              if (
                !/[0-9]/.test(e.key) &&
                !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)
              ) {
                e.preventDefault();
              }
            }}
          />
        </Box>
      }
      primaryAction={{
        content: t('common:button.print_label'),
        disabled: !quantity || parseInt(quantity, 10) <= 0,
        onAction: () => {
          proceed({ confirmed: true, quantity: parseInt(quantity, 10) });
        },
      }}
      onClose={() => {
        proceed({ confirmed: false, quantity: null });
      }}
    />
  );
}

export default confirmable(PrintlabelDialog);
